import React, { useContext } from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import { CartContext } from '../App';
import { FiHeart, FiShoppingCart, FiEye } from 'react-icons/fi';

export default function ProductCard({ product, showToast }) {
  const { addToCart, wishlist, toggleWishlist } = useContext(CartContext);
  const isWishlisted = wishlist.find(p => p.id === product.id);

  const [showModal, setShowModal] = React.useState(false);

  const handleAddToCart = () => {
    addToCart(product);
    if (showToast) showToast(`${product.name} added to cart!`);
    setShowModal(true);
  };

  const handleWishlist = () => {
    toggleWishlist(product);
    if (showToast) showToast(isWishlisted ? 'Removed from wishlist' : 'Added to wishlist!');
  };

  return (
    <div className="product-card">
      <div className="product-card-image">
        <img src={product.image} alt={product.name} loading="lazy" />
        <div className="product-overlay">
          {product.size && product.size.length > 0 ? (
            <Link to={`/product/${product.id}`} className="overlay-btn">
              <FiShoppingCart /> Select Size
            </Link>
          ) : (
            <button className="overlay-btn" onClick={handleAddToCart}>
              <FiShoppingCart /> Add to Cart
            </button>
          )}
          <Link to={`/product/${product.id}`} className="overlay-btn secondary">
            <FiEye /> View Product
          </Link>
        </div>
        <button
          className={`wishlist-btn${isWishlisted ? ' active' : ''}`}
          onClick={handleWishlist}
          title={isWishlisted ? 'Remove from wishlist' : 'Add to wishlist'}
        >
          <FiHeart />
        </button>
      </div>
      <div className="product-card-body">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
          <div className="product-category-tag" style={{ margin: 0 }}>{product.category} — {product.subcategory}</div>
          <div style={{
            fontSize: '0.75rem',
            fontWeight: 700,
            background: '#f8fafc',
            padding: '4px 8px',
            borderRadius: '4px',
            border: '1px solid #e2e8f0',
            color: '#334155',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
          }}>
            🏢 {product.brand}
          </div>
        </div>
        <h3 className="product-name" style={{ marginTop: '4px' }}>{product.name}</h3>
        <div className="product-price-row">
          <span className="product-price">Rs. {product.price.toLocaleString()}</span>
          <div className="product-rating">
            {'★'.repeat(Math.round(product.rating))}{'☆'.repeat(5 - Math.round(product.rating))}
            <span style={{ color: '#aaa', marginLeft: 4 }}>({product.reviews})</span>
          </div>
        </div>
      </div>
      {showModal && ReactDOM.createPortal(
        <>
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.5)', zIndex: 9998 }} onClick={() => setShowModal(false)} />
          <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', background: '#fff', padding: '30px', borderRadius: '8px', zIndex: 9999, width: '90%', maxWidth: '400px', textAlign: 'center', boxShadow: '0 10px 25px rgba(0,0,0,0.2)' }}>
            <div style={{ fontSize: '3rem', color: '#16a34a', marginBottom: '10px' }}>✓</div>
            <h3 style={{ marginBottom: '10px', color: '#000' }}>Added!</h3>
            <p style={{ color: '#555', marginBottom: '24px' }}>Your product has been added to cart.</p>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
              <Link to="/cart" className="btn-primary" style={{ padding: '10px 20px', textDecoration: 'none', background: 'var(--primary)', color: '#fff', borderRadius: '4px', border: 'none', fontWeight: 600 }}>View Cart</Link>
              <button onClick={() => setShowModal(false)} style={{ padding: '10px 20px', background: '#e0e0e0', color: '#333', borderRadius: '4px', border: 'none', fontWeight: 600, cursor: 'pointer' }}>Continue</button>
            </div>
          </div>
        </>,
        document.body
      )}
    </div>
  );
}
